var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrustedIconGlobeA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    overflow: "visible",
    style: {
      display: "block"
    },
    viewBox: "0 0 6.6507 11.7092",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.32008 0H0C0.236485 0.647462 0.365684 1.34619 0.365684 2.07446V10.843C0.365684 11.1467 0.312833 11.4381 0.21668 11.7092H4.05229C5.48509 11.7092 6.6507 10.5435 6.6507 9.11076V4.33061C6.65076 1.94274 4.70802 0 2.32008 0Z",
    fill: "var(--fill-0, white)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrustedIconGlobeA);
export default __webpack_public_path__ + "static/media/trusted-icon-globe-a.09f9e09975ec48eaa33ad0458b31bddc.svg";
export { ForwardRef as ReactComponent };